:global(html, body) {
    margin: 0;
    padding: 0;
}

.container {
    // Do not allow this container to have a "scrolling mechanism" or it will break position sticky everywhere
    // aka do NOT set overflow to hidden, scroll, auto, or overlay
    composes: grid from "../../styles/layout.module.scss";
    grid-auto-rows: max-content;

    :where(&) {
        --default-columns: content;
    }
}
